import { useFormatters } from "@/lib/hooks/useFormatters";
import { DateTime } from "luxon";
import { DateRange } from "react-day-picker";
import { useTranslation } from "react-i18next";

export function useGetSelectedLabel(selected?: DateRange): string {
  const { t, i18n } = useTranslation();

  const { formatDayMonth, formatlDayMonthYear } = useFormatters();

  if (!selected?.from || !selected?.to) {
    return t("datePicker.pickADate");
  }

  const from = DateTime.fromJSDate(selected.from).setLocale(i18n.language);
  const to = DateTime.fromJSDate(selected.to).setLocale(i18n.language);

  if (!from.isValid || !to.isValid) {
    return t("datePicker.pickADate");
  }

  if (from.year === to.year) {
    return `${formatDayMonth(from)} - ${formatDayMonth(to)}`;
  }
  return `${formatlDayMonthYear(from)} - ${formatlDayMonthYear(to)}`;
}
